import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import {IndexPage} from 'features/home/pages/IndexPage';

import {IndexPage as AboutPage} from 'features/about/pages/IndexPage';

import {IndexPage as CredentialsPage} from 'features/credentials/pages/IndexPage';

import {IndexPage as RedirectPage} from 'features/redirect/pages/IndexPage';

import {RequestPage as ResetPasswordRequestPage} from 'features/reset-password/pages/RequestPage';
import {ConfirmPage as ResetPasswordConfirmPage} from 'features/reset-password/pages/ConfirmPage';
import {SelectionPage as ResetPasswordSelectionPage} from 'features/reset-password/pages/SelectionPage';

import {IndexPage as MethodSelectionPage} from 'features/method-selection/pages/IndexPage';

import {IndexPage as ChangePasswordPage} from 'features/change-password/pages/IndexPage';

import {IndexPage as AccountsPage} from 'features/accounts/pages/IndexPage';
import {AddPage as AddAccountPage} from 'features/accounts/pages/AddPage';

// import UserAgreementsLayout from 'features/user-agreements/layout';
import {PageNotFoundPage} from 'features/home/pages/PageNotFoundPage';
import {OfflinePage} from 'features/home/pages/OfflinePage';

import DefaultLayout from 'layout/DefaultLayout';

import UserAgreementsLayout from 'features/user-agreements/layout';
import {IndexPage as UserAgreementsIndexPage} from 'features/user-agreements/pages/IndexPage';
import {AcceptancePage} from 'features/user-agreements/pages/AcceptancePage';

import {ViewTermsOfUsePage} from 'features/user-agreements/pages/ViewTermsOfUsePage';

import SigninOptionsLayout from 'features/signin-options/layout';

import {SigninOptionsContextProvider} from 'context/SigninOptionsContext';
import {ApplicationsContextProvider} from 'context/ApplicationsContext';
import {AccountsContextProvider} from 'context/AccountsContext';

import {MantineProvider} from '@mantine/core';

// var cookies = document.cookie.split(";");
var cookies = document.cookie;
console.debug('cookies', cookies)


const App = () => (
    <MantineProvider
        theme={{
            breakpoints: {
                xs: 500,
                sm: 800,
                md: 1000,
                lg: 1200,
                xl: 1400,
            },
            fontFamily: 'Inter, Roboto, sans-serif',
        }}
    >
        <AccountsContextProvider>
            <SigninOptionsContextProvider>
                <ApplicationsContextProvider>
                    <Routes>
                        <Route path="/" element={<DefaultLayout/>}>
                            <Route
                                path="login"
                                element={<Navigate to="/redirect"/>}
                            />
                            <Route
                                path="/redirect/:account"
                                element={<RedirectPage/>}
                            />

                            <Route
                                path="method-selection/:account"
                                element={<MethodSelectionPage/>}
                            />
                            <Route
                                path="credentials/:account"
                                element={<CredentialsPage/>}
                            />

                            <Route
                                path="reset-password/confirm/:account"
                                element={<ResetPasswordConfirmPage/>}
                            />
                            <Route
                                path="reset-password/selection/:account"
                                element={<ResetPasswordSelectionPage/>}
                            />
                            <Route
                                path="reset-password/request/:account"
                                element={<ResetPasswordRequestPage/>}
                            />

                            <Route
                                path="change-password/:account"
                                element={<ChangePasswordPage/>}
                            />

                            <Route
                                path="signin-options/*"
                                element={<SigninOptionsLayout/>}
                            />


                            <Route
                                path="accounts"
                                element={<AccountsPage/>}
                            ></Route>
                            <Route
                                path="accounts/add"
                                element={<AddAccountPage/>}
                            />

                            <Route path="/index.html" element={<IndexPage/>}/>

                            <Route path="/" element={<IndexPage/>}/>
                            <Route path="/about" element={<AboutPage/>}/>
                            <Route path="/404" element={<PageNotFoundPage/>}/>
                            <Route path="/offline" element={<OfflinePage/>}/>
                            <Route path="*" element={<PageNotFoundPage/>}/>
                        </Route>

                        <Route
                            path="user-agreements"
                            element={<UserAgreementsLayout/>}
                        >
                            <Route
                                path="acceptance/:account"
                                element={<AcceptancePage/>}
                            />
                            <Route
                                path="terms-of-use"
                                element={<ViewTermsOfUsePage/>}
                            />
                            <Route
                                path="list"
                                element={<UserAgreementsIndexPage/>}
                            />
                        </Route>
                    </Routes>
                </ApplicationsContextProvider>
            </SigninOptionsContextProvider>
        </AccountsContextProvider>
    </MantineProvider>
);

// Hub.listen(/.*/, (hubData) => {
//     const { event, data } = hubData.payload;
//     console.debug('EVENT', event);
//     console.debug('DATA', data);

//     if (event === 'networkStatus') {
//         console.debug(`User has a network connection: ${data.active}`);
//     }
// });

export default App;